<template>
  <section class="vbox">    
    <section class="scrollable wrapper">
      <div class="content-header">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item><a href="/">营销</a></el-breadcrumb-item>
          <el-breadcrumb-item>买单</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <el-form ref="form" v-model="consumeActive" label-width="160px" >
        <el-form-item label="活动名称">
          <el-col :span="11">
            <el-input v-model="consumeActive.name" ></el-input>
          </el-col>
        </el-form-item> 
        <el-form-item label="所属门店">
          <el-col :span="11">      
            <el-input v-model="storeName" readonly placeholder="名称">
              <el-button  slot="append" icon="el-icon-search" @click="selectStoreHandle"></el-button>
            </el-input>  
          </el-col>
        </el-form-item> 
        <Templata :floorData="items" :couponPackages="couponPackages" @UpdateItems="UpdateItems"></Templata>  
        <el-form-item >
          <el-col :span="11">
            <el-button type="primary" @click="Save">确 定</el-button>
          </el-col>
        </el-form-item>
      </el-form>
    </section>
    <GetChainStore v-bind:dialogStore="dialogStore" @UpdateSote="UpdateSote"></GetChainStore>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import Templata from './item'  
  import GetChainStore from '@/components/GetChainStore'
  export default {
    
    data (){
      return {
        consumeActive:{}, 
        dialogStore:{
          isShow:false
        },
        items:[],
        couponPackages:[],
        storeName:''
      }
    },
    computed:{   
         
    },
    mounted(){
      var that = this
      this.axios({
        method:'get',
        url:that.global.serverSrc + '/api/ConsumeActive/Get',         
        params:{
          id:that.$route.params.Id
        }
      }).then(function (resp) {
        that.storeName = resp.data.storeName
        that.couponPackages = resp.data.couponPackages
        that.consumeActive = resp.data.consumeActive        
        that.items=resp.data.items   
      })
    },
    methods:{       
      selectStoreHandle:function(){
        this.dialogStore.isShow = true
      },   
      UpdateSote:function(id,name){
        this.consumeActive.chainStoreId = id 
        this.storeName = name 
      },   
      UpdateItems:function(data){
        this.items = data        
        console.log(JSON.stringify(this.items))
      }, 
      Save:function(){
        var that = this
        for(let i=this.items.length-1; i>=0; i--){
          if(this.items[i].itemId == ''){
            this.items.splice(i,1);
          }
        }
        that.consumeActive.ConsumeActiveItems =JSON.stringify(that.items)
        this.axios({
          method:'post',
          url:that.global.serverSrc + '/api/consumeActive/Save',         
          data: that.consumeActive
        }).then(function (resp) {
          if(resp.data.errorCode==0){
            that.$message.success(resp.data.message);
          }else {
            that.$message.warning(resp.data.message);
          }  
        }).catch(resp => {         
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      updateDescription(data){
        this.coupon.description=data
      },
      
    },
    components:{  
      Templata,
      GetChainStore
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
  .content-header
    padding 24px
    border 1px solid #C0C4CC
    margin-bottom 24px
  .icon-uploader
    .el-upload
      border 1px dashed #d9d9d9
      border-radius 6px
      cursor pointer
      position relative
      overflow hidden
      .el-upload
      &:hover
        border-color #409EFF
      img
        width 100px
        height 100px
  .icon-uploader-icon
    font-size 28px
    color #8c939d
    width 100px
    height 100px
    line-height 100px
    text-align center  
</style>